import React from 'react';
import { Box, Typography } from '@mui/material';
import { ScreenWarningContainer } from './ScreenSizeWarning.styles';
import { ReactComponent as VeernyIcon } from '../../assets/veerny-icon.svg';

const ScreenSizeWarning: React.FC = () => {
  return (
    <ScreenWarningContainer>
      <Box sx={{ marginBottom: '19px', width: '42px', height: '50px', flexShrink: 0 }}>
        <VeernyIcon width="100%" height="100%" />
      </Box>
      <Typography variant="h1" align="center" sx={{ lineHeight: 1.3 }}>
        This page isn’t available <br /> at this screen size
      </Typography>
      <Typography variant="body2" align="center" sx={{ marginTop: 1, lineHeight: 1.3 }}>
        Please widen your browser <br /> window to continue
      </Typography>
    </ScreenWarningContainer>
  );
};

export default ScreenSizeWarning;
